import styled from "styled-components";
import { Typography } from "antd";

export const RadioGroupLabel = styled(Typography)`
  font-size: 16px;
  font-weight: 500;
  color: #192849;
`;
